import { P2GBox, P2GGrid } from '@parcel2go/core-ui';
import { P2GRadio } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import {
  PaymentOptionApiModel,
  PaymentOptionOptionApiModel,
  PaymentOptionType,
  VerifyShipResponse
} from '~/lib/api/smartsend/types';
import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import PaymentLabel from './PaymentLabel';
import { P2GDropdown } from '@parcel2go/core-ui';
import ProviderGroupPromoCode from './ProviderGroupPromoCode';
import ProviderGroupSummaryTotal from './ProviderGroupSummaryTotal';
import P2GOptionContainer from '~/components/option-container/option-container';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

interface props {
  group: ProviderGroup;
  updateSelectedPaymentOption: (option: PaymentOptionType, optionOption: PaymentOptionOptionApiModel) => void;
  updateDiscountCode: (discountCode: string) => void;
  paymentOptions: PaymentOptionApiModel[];
  close: () => void;
  verifyShip: (group: ProviderGroup) => Promise<VerifyShipResponse>;
}

const ProviderGroupSummaryIdle: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <>
      <ProviderGroupSummaryTotal group={props.group} verifyShip={props.verifyShip} />
      <ProviderGroupPromoCode updateDiscountCode={props.updateDiscountCode} group={props.group} />
      {props.paymentOptions.length > 1 && (
        <P2GBox mt={2}>
          <P2GText component="p" colour="primary">
            <Trans i18nKey="PAYMENT_OPTIONS_SUBTTILE" t={t} defaults="<strong>Payment Options</strong>" />
          </P2GText>
          <P2GGrid container direction="column" gap={2} mt={2}>
            {props.paymentOptions.map((o) => (
              <P2GGrid key={o.Type}>
                <P2GOptionContainer variant="payment-option" selected={o.Type === props.group.SelectedPaymentMethod}>
                  <P2GRadio
                    name="SelectedPaymentOption"
                    value={o.Type}
                    disabled={o.Type === 'TopUp' && Number(o.Balance) < Number(props.group.TotalPrice)}
                    checked={o.Type === props.group.SelectedPaymentMethod}
                    onChange={() =>
                      props.updateSelectedPaymentOption(o.Type, props.group.SelectedPaymentOption || o.Options[0])
                    }
                    id="Selected"
                    label={
                      <PaymentLabel close={props.close} paymentType={o} option={props.group.SelectedPaymentOption} />
                    }
                  />
                  {o.Type === props.group.SelectedPaymentMethod && o.Options.length > 0 && (
                    <P2GBox>
                      <P2GDropdown
                        id="Options"
                        value={props.group.SelectedPaymentOption?.Id}
                        options={o.Options.map((x) => {
                          return { value: x.Id, text: x.Display };
                        })}
                        onChange={(v) =>
                          props.updateSelectedPaymentOption(
                            o.Type,
                            o.Options.find((o) => o.Id === v)
                          )
                        }
                        label={t('SELECT_PAYMENT_OPTION', { defaultValue: 'Select Payment Option' })}
                      />
                    </P2GBox>
                  )}
                </P2GOptionContainer>
              </P2GGrid>
            ))}
          </P2GGrid>
        </P2GBox>
      )}
    </>
  );
};

export default ProviderGroupSummaryIdle;
